// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Hover from "../../primitives/Hover.res.js";
import * as React from "react";
import * as Button from "../actions/Button.res.js";
import * as Offset from "../layout-and-structure/Offset.res.js";
import * as Spinner from "../feedback-indicators/Spinner.res.js";
import * as FontSizes from "../theme/FontSizes.res.js";
import * as TextInput from "../../primitives/TextInput.res.js";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as LegacyIcon from "../images-and-icons/LegacyIcon.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as AnimatedRender from "../../primitives/AnimatedRender.res.js";
import * as TextFieldStyle from "./TextFieldStyle.res.js";
import * as ReactDomElement from "../../primitives/ReactDomElement.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
function InputSearch$SearchPrepender(props) {
  let onRequestInputFocus = props.onRequestInputFocus;
  let loading = props.loading;
  let newrecord = {
    ...{
      style: {
        height: "18px",
        position: "relative",
        width: "16px"
      }
    }
  };
  let newrecord$1 = {
    ...{
      style: {
        left: "0.5px",
        position: "absolute"
      }
    }
  };
  newrecord.children = [JsxRuntime.jsx("div", (newrecord$1.children = JsxRuntime.jsx(AnimatedRender.make, {
    children: JsxRuntime.jsx(Spinner.make, {
      size: 14
    }),
    displayed: loading,
    animation: "fade",
    duration: 250
  }), newrecord$1)), JsxRuntime.jsx(AnimatedRender.make, {
    children: JsxRuntime.jsx(Touchable.make, {
      children: JsxRuntime.jsx(LegacyIcon.make, {
        name: "search",
        fill: "#bdbdca",
        size: 16.5,
        stroke: "#bdbdca"
      }),
      excludeFromTabOrder: true,
      style: {
        cursor: "default"
      },
      onPress: param => onRequestInputFocus()
    }),
    displayed: !loading,
    animation: "fade",
    duration: 100
  })];
  return JsxRuntime.jsxs("div", newrecord);
}
let styles = {
  root: {
    "opacity-kSiTet": "opacity-x1ks1olk",
    ":not(:hover)_backgroundColor-kmRCyk": "backgroundColor-x1lujfql",
    $$css: "wino-gc:src/resources/selection-and-input/InputSearch.res.js:64"
  }
};
function InputSearch$EraseAppender(props) {
  let onRequestInputClear = props.onRequestInputClear;
  let onRequestInputFocus = props.onRequestInputFocus;
  return JsxRuntime.jsx(Offset.make, {
    children: JsxRuntime.jsx(Button.make, {
      ariaProps: {
        "aria-label": "clear",
        preventFocusOnPress: true
      },
      variant: {
        NAME: "ghost",
        VAL: {}
      },
      size: "small",
      icon: "cross",
      iconSize: 15,
      excludeFromTabOrder: true,
      stylex: Primitive_option.some(styles.root),
      onPress: () => {
        onRequestInputFocus();
        onRequestInputClear();
      }
    }),
    right: -8.5,
    width: 32,
    height: 32
  });
}
function style(focused, hovered, disabled, bordered) {
  return {
    backgroundColor: TextFieldStyle.backgroundColor(disabled),
    border: bordered ? "1px solid" : "none",
    borderColor: TextFieldStyle.borderColor(focused, hovered, false, disabled),
    display: "flex",
    height: "40px",
    overflow: "hidden",
    padding: `0 ` + "12px",
    borderRadius: TextFieldStyle.borderRadiusPx,
    columnGap: "8px",
    alignItems: "center",
    flexDirection: "row",
    boxSizing: "border-box"
  };
}
function textInputStyle(disabled) {
  return {
    color: TextFieldStyle.color(disabled),
    fontSize: FontSizes.smallPx,
    height: "35px",
    width: "0",
    flex: "1",
    textOverflow: "ellipsis"
  };
}
function InputSearch(props) {
  let __value = props.value;
  let ariaProps = props.ariaProps;
  let __focused = props.focused;
  let __bordered = props.bordered;
  let __disabled = props.disabled;
  let disabled = __disabled !== undefined ? __disabled : false;
  let bordered = __bordered !== undefined ? __bordered : true;
  let focused = __focused !== undefined ? __focused : false;
  let value = __value !== undefined ? __value : "";
  let inputRef = Stdlib_Option.getOr(props.inputRef, React.useRef(null));
  let match = Hover.use(props.containerRef, undefined, undefined);
  let focusInput = () => {
    let input = inputRef.current;
    if (!(input == null)) {
      return ReactDomElement.focus(input);
    }
  };
  let style$1 = style(focused, match[1], disabled, bordered);
  let textInputStyle$1 = textInputStyle(disabled);
  let value$1 = Stdlib_Option.getOr(Stdlib_Option.flatMap(ariaProps, ariaProps => ariaProps.value), value);
  return JsxRuntime.jsxs("div", {
    children: [JsxRuntime.jsx(InputSearch$SearchPrepender, {
      loading: props.loading,
      onRequestInputFocus: focusInput
    }), JsxRuntime.jsx(TextInput.make, {
      inputRef: Primitive_option.some(inputRef),
      ariaProps: ariaProps,
      placeholder: props.placeholder,
      readOnly: disabled,
      autoFocus: props.autoFocus,
      style: textInputStyle$1,
      value: value$1,
      onChange: props.onChange,
      onFocus: props.onFocus,
      onBlur: props.onBlur
    }), value$1 !== "" && !disabled ? JsxRuntime.jsx(InputSearch$EraseAppender, {
      onRequestInputFocus: focusInput,
      onRequestInputClear: props.onRequestClear
    }) : null],
    ref: Primitive_option.some(match[0]),
    style: style$1
  });
}
let make = React.memo(InputSearch);
export { make };
/* styles Not a pure module */